__turbopack_context__.v({
  "member-link-span": "styles-module__FbbKIq__member-link-span",
  "profile-image-wrapper": "styles-module__FbbKIq__profile-image-wrapper",
  "shadow-wrapper": "styles-module__FbbKIq__shadow-wrapper",
  "text-wrapper": "styles-module__FbbKIq__text-wrapper",
});
